export default __webpack_public_path__ + "static/media/DinosaursFlyingRetiples_11.425f4c8a.png";